// Программы вузов — направления, по которым семья встречается с программой.
//
// Код направления программы — идентификатор кластера карьерного теста
// careers_1822 (тот же, что result_snapshots.cluster_1..3_id). Список здесь,
// CHECK в миграции 20261005120000_edu_programs.sql и кластеры в
// src/data/careers_1822_ru.json — одна величина в трёх местах. Их сверяет
// scripts/verify-edu-programs.mts: два списка одной величины расходятся тихо.

import type { FieldCode } from "./fields-of-study";

export const PROGRAM_CLUSTER_IDS = [
  "finance",
  "business",
  "procurement",
  "marketing",
  "sales",
  "hr",
  "technology",
  "design",
  "media",
  "education",
  "healthcare",
  "law",
  "engineering",
  "trades_technical",
  "science",
  "government",
  "hospitality",
  "environment",
  "social",
  "agriculture",
  "sports_beauty",
  "real_estate",
  "creative_arts",
] as const;

export type ProgramClusterId = (typeof PROGRAM_CLUSTER_IDS)[number];

// ШИРОКАЯ ГРУППА НАПРАВЛЕНИЯ — для подбора вузов (19.10.2026).
//
// Узкий кластер профтеста («продажи», «закупки») сам по себе почти не
// встречается в разметке программ: вуз пишет «бизнес», а не «переговоры». Вуз
// и семья сравниваются по группам: совпала хоть одна группа — вуз показан.
// Группы — те же восемь, что в словаре направлений (fields-of-study.ts).
// Кластер на стыке входит в обе группы.
export const PROGRAM_CLUSTER_FIELDS: Record<ProgramClusterId, readonly FieldCode[]> = {
  finance: ["economics"],
  business: ["economics"],
  procurement: ["economics"],
  marketing: ["economics"],
  sales: ["economics"],
  hr: ["economics"],
  hospitality: ["economics"],
  real_estate: ["economics", "engineering"],
  agriculture: ["economics", "natural_sci"],
  technology: ["math_cs"],
  engineering: ["engineering"],
  trades_technical: ["engineering"],
  science: ["natural_sci"],
  environment: ["natural_sci"],
  healthcare: ["medicine"],
  sports_beauty: ["medicine"],
  education: ["humanities"],
  social: ["humanities"],
  media: ["humanities", "arts"],
  government: ["humanities", "law"],
  law: ["law"],
  design: ["arts"],
  creative_arts: ["arts"],
};

/** Группы кластеров. Незнакомый код — пусто: по нему не сравниваем. */
export function clusterFields(ids: Iterable<string>): Set<FieldCode> {
  const out = new Set<FieldCode>();
  for (const id of ids) for (const f of (PROGRAM_CLUSTER_FIELDS as Record<string, readonly FieldCode[]>)[id] ?? []) out.add(f);
  return out;
}
